export const eur = (n: number) =>
  new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(n);

export function parseAmountInput(s: string): number | null {
  const t = s.trim().replace(',', '.');
  const n = Number(t);
  if (!Number.isFinite(n) || n <= 0) return null;
  return n;
}

export function amountToInputString(n: number): string {
  const s = String(n);
  if (s.includes('e') || s.includes('E')) return String(Number(n));
  return s.replace('.', ',');
}
